import { Resource } from "i18next";
import t from "../../locales/fr.json";

export default t as Resource;
